import React from "react";
import { useDashboardContext } from "@/contexts/DashboardContext";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  LayoutDashboard,
  User,
  Briefcase,
  Clock,
  Bell,
  Settings,
  ChevronDown,
} from "lucide-react";
import { cn } from "@/lib/utils";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";

const menuItems = [
  // {
  //   id: "overview" as const,
  //   label: "Overview",
  //   icon: LayoutDashboard,
  // },
  // New Overview V2 menu item
  {
    id: "overview" as const,
    label: "Overview",
    icon: LayoutDashboard,
  },
  {
    id: "profile" as const,
    label: "About Me",
    icon: User,
  },
  {
    id: "portfolio" as const,
    label: "Portfolio",
    icon: Briefcase,
  },
  {
    id: "experience" as const,
    label: "Experience",
    icon: Clock,
  },
  {
    id: "notifications" as const,
    label: "Notifications",
    icon: Bell,
  },
  {
    id: "settings" as const,
    label: "Settings",
    icon: Settings,
  },
];

export default React.memo(function DashboardSidebar() {
  const { activeSection, navigateToSection } = useDashboardContext();
  const activeItem = menuItems.find((item) => item.id === activeSection) || menuItems[0];

  return (
    <>
      {/* Mobile: Dropdown */}
      <div className="block md:hidden bg-white p-4 rounded-lg">
        <Select
          value={activeSection}
          onValueChange={navigateToSection}
        >
          <SelectTrigger
            className="w-full"
          >
            <div className="flex flex-row items-center gap-2">
              {activeItem.icon && (
                <activeItem.icon className="h-4 w-4" />
              )}
              <span>{activeItem.label}</span>
            </div>
          </SelectTrigger>
          <SelectContent className="w-full">
            {menuItems.map((item) => {
              const isPortfolio = item.id === "portfolio";
              return (
                <SelectItem key={item.id} value={item.id} className="py-3 data-[state=checked]:bg-gray-200 data-[state=checked]:text-gray-900">
                  <span className="flex flex-row items-center gap-3 text-base w-full">
                    <item.icon className="h-4 w-4 mr-2" />
                    <span className="whitespace-nowrap flex-1">{item.label}</span>
                    {isPortfolio && (
                      <Badge 
                        variant="secondary" 
                        className="text-xs px-2 py-0.5 bg-orange-100 text-orange-500 border-orange-200 font-light"
                      >
                        New
                      </Badge>
                    )}
                  </span>
                </SelectItem>
              );
            })}
          </SelectContent>
        </Select>
      </div>

      {/* Desktop: Sidebar */}
      <div className="hidden md:block bg-white rounded-lg border border-gray-200 p-4">
        <nav className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeSection === item.id;
            const isPortfolio = item.id === "portfolio";

            return (
              <Button
                key={item.id}
                variant={isActive ? "default" : "ghost"}
                className={cn(
                  "w-full justify-start relative",
                  isActive && "bg-primary text-primary-foreground"
                )}
                onClick={() => navigateToSection(item.id)}
              >
                <Icon className="mr-3 h-4 w-4" />
                {item.label}
                {isPortfolio && (
                  <Badge 
                    variant="secondary" 
                    className="ml-auto text-xs font-medium px-2 py-0.5 bg-orange-100 text-orange-800 border-orange-200"
                  >
                    Beta
                  </Badge>
                )}
              </Button>
            );
          })}
        </nav>
      </div>
    </>
  );
});
